import type { ComponentCommonAuthor } from '@edwin-group/cj-graphql/generated/graphql';
import { format } from 'date-fns';
import classNames from 'classnames';

export default function DefaultContentTemplateAuthor({
  component,
  className,
  isDefaultContentTemplate = false,
}: {
  component: ComponentCommonAuthor;
  className?: string;
  isDefaultContentTemplate?: boolean;
}) {
  const authors = component?.author?.data?.attributes?.name;
  const role = component?.author?.data?.attributes?.role;

  return (
    <>
      {component?.publicationDate && (
        <p
          className={classNames('text-sh-xxs text-sh-grey-4e', className, {
            'my-0': isDefaultContentTemplate,
            'mb-sh-5': !isDefaultContentTemplate,
          })}>
          {format(new Date(component?.publicationDate), 'dd.MM.yyyy')?.toUpperCase()}
        </p>
      )}
      {authors && (
        <p
          className={classNames('text-sh-xxs text-sh-grey-4e', className, {
            'mt-0': isDefaultContentTemplate,
            'mt-sh-5': !isDefaultContentTemplate,
          })}>
          By <strong>{authors}</strong>
          {role ? `, ${role}` : null}
        </p>
      )}
    </>
  );
}
